module.exports = __webpack_public_path__ + "static/media/recommended-3.15ff998e.png";